<template>
    <Button :icon="icon" :class="classname" :ghost="ghost" @click="download()" :type="type" :size="size" :loading="loading"><slot></slot></Button>
</template>
<script>
export default {
	name: 'btn',
	props: {
        icon:{
            type:String,
            default:'md-cloud-download'
        },
        classname:{
            type:String,
            default:'gyl-btn downloadbtn'
        },
		ghost: {
			type: Boolean,
			default:false
        },
        loading: {
			type: Boolean,
			default:false
		},
		type: {
			type: String,
			default:'primary'
		},
		size: {
			type: String,
			default:'small'
		},
		data: {
			type: Object,
			default:() => ({})
		},
		callback: {
			type: Boolean,
			default:false
        },
        query:{
			type: Object,
            default:() => ({})
        },
        url:{
            type:String,
            default:'/gyl/ec_info/findOrDownImage'
        },
        ajaxType:{
            type: String,
			default:'downloadGet'
        },
        fileFont:{
            type: String,
            default:'xxx'
        }
	},
	data() {
		return {
			auth:{}
		}
	},
	created(){
	},
	computed: {
	},
	methods: {
        download(){
            this.$ajax[this.ajaxType](this.url,this.query).then(res => {
                console.log("res",res)
                let filename = this.fileFont;

                if(res.headers&&res.headers["content-disposition"])filename = res.headers["content-disposition"].split(";")[1].split("filename=")[1];
                if(this.ajaxType == 'preview'){var res = res.data;}
                if(this.query.type == 'oneKey'||this.query.downloadType == '01'){ //downloadType == '01'为SCF买方付息资产一键下载做兼容
                    this.creatA(res.data,decodeURI(filename))
                }else{
                    this.creatA(res,decodeURI(filename))
                }
                console.log("decodeURI(filename)",res)
            })
        },
        creatA(data,filename){
            if(!data||data.size==0){
                this.$Message.error({content:'下载失败',closable: true});
                return;
            }
            if('msSaveOrOpenBlob' in navigator){
                window.navigator.msSaveOrOpenBlob(new Blob([data]),filename)
            }else{
                let url = window.URL.createObjectURL(new Blob([data]));
                let link = document.createElement('a');
                link.style.display='none';
                link.href=url;
                link.setAttribute('download',filename)
                document.body.appendChild(link)
                link.click();
            }
        },
	}
}
</script>



// WEBPACK FOOTER //
// src/components/inc/component/myDownload.vue